module.exports = __webpack_public_path__ + "assets/img/introduceFive.cb821db0.png";